// extracted by mini-css-extract-plugin
export var box = "colorLift-module--box--o8slU";
export var imageContainer = "colorLift-module--imageContainer--E3eiP";
export var textBox = "colorLift-module--textBox--rXvz+";